module.exports = __webpack_public_path__ + "img/contacts_plus.6cbb871c.png";